// import React, { useEffect, useRef } from "react";
// import "./HomePage.scss";
// import HeaderSlider from "../../components/Slider/HeaderSlider";
// import { useSelector, useDispatch } from "react-redux";
// import {
//   getAllCategories,
//   fetchAsyncCategories,
// } from "../../store/categorySlice"; // Assurez-vous d'importer la fonction pour récupérer les catégories
// import ProductList from "../../components/ProductList/ProductList";
// import {
//   fetchAsyncProducts,
//   getAllProducts,
//   getAllProductsStatus,
// } from "../../store/productSlice";
// import Loader from "../../components/Loader/Loader";
// import { STATUS } from "../../utils/status";
// import { Link } from "react-router-dom";
// import Footer1 from "../../components/Footer/Footer1";
// import Header1 from "../../components/Header/Header1";

// const HomePage = () => {
//   const dispatch = useDispatch();

//   useEffect(() => {
//     dispatch(fetchAsyncProducts(50));
//     dispatch(fetchAsyncCategories()); // Récupérer les catégories
//   }, [dispatch]);

//   const products = useSelector(getAllProducts);
//   const productStatus = useSelector(getAllProductsStatus);
//   const categories = useSelector(getAllCategories);
//   const scrollRef = useRef(null);

//   useEffect(() => {
//     const scroll = () => {
//       if (scrollRef.current) {
//         scrollRef.current.scrollLeft += 1; // Ajuste la vitesse de défilement ici
//       }
//     };

//     const interval = setInterval(scroll, 50); // Ajuste la durée de l'intervalle ici

//     return () => clearInterval(interval); // Nettoie l'intervalle à la désactivation du composant
//   }, []);

//   return (
//     <main>
//       <div className="slider-wrapper">
//         <HeaderSlider />
//       </div>
//       <div className="main-content bg-whitesmoke">
//         <div className="container">
//           <div className="categories py-2">
//             <div className="categories-item">
//               <div className="title-md">
//                 {/* <h3>See some categories</h3> */}
//                 <ul
//                   className="navbar-nav flex align-center fs-2 fw-4 font-manrope categories-scroll"
//                   ref={scrollRef}
//                 >
//                   {categories.slice(0, 10).map((category) => {
//                     // Vérification de l'objet catégorie
//                     const displayCategory = category?.name?.replace("-", " ");

//                     return (
//                       <li className="nav-item no-wrap" key={category.id}>
//                         <Link
//                           to={`/category/${category.id}`} // Utilisation de l'id au lieu de slug
//                           className="nav-link text-capitalize"
//                         >
//                           {displayCategory}
//                         </Link>
//                       </li>
//                     );
//                   })}
//                 </ul>
//               </div>
//             </div>
//             <Header1 />
//             <div className="categories-item">
//               <div className="title-md d-flex justify-content-between align-items-center">
//                 <h3>See some Products</h3>
//                 <Link to="/AllProducts" className="text-decoration-none">
//                   <span className="see-all">See All Products</span>
//                 </Link>
//               </div>
//               {productStatus === STATUS.LOADING ? (
//                 <Loader />
//               ) : (
//                 <ProductList products={products} />
//               )}
//             </div>
//           </div>
//         </div>
//         <Footer1 />
//       </div>
//     </main>
//   );
// };

// export default HomePage;
import React, { useEffect, useRef } from "react";
import "./HomePage.scss";
import HeaderSlider from "../../components/Slider/HeaderSlider";
import { useSelector, useDispatch } from "react-redux";
import {
  getAllCategories,
  fetchAsyncCategories,
} from "../../store/categorySlice";
import ProductList from "../../components/ProductList/ProductList";
import {
  fetchAsyncProducts,
  getAllProducts,
  getAllProductsStatus,
} from "../../store/productSlice";
import Loader from "../../components/Loader/Loader";
import { STATUS } from "../../utils/status";
import { Link } from "react-router-dom";
import Footer1 from "../../components/Footer/Footer1";
import Header1 from "../../components/Header/Header1";

const HomePage = () => {
  const dispatch = useDispatch();
  const categories = useSelector(getAllCategories);
  const products = useSelector(getAllProducts);
  const productStatus = useSelector(getAllProductsStatus);

  const carouselRef = useRef(null);

  useEffect(() => {
    dispatch(fetchAsyncProducts(50));
    dispatch(fetchAsyncCategories());
  }, [dispatch]);

  const autoScroll = () => {
    if (carouselRef.current) {
      const { scrollWidth, scrollLeft, clientWidth } = carouselRef.current;

      if (scrollLeft < scrollWidth - clientWidth) {
        carouselRef.current.scrollBy({ left: 300, behavior: "smooth" });
      } else {
        carouselRef.current.scrollTo({ left: 0, behavior: "smooth" });
      }
    }
  };

  useEffect(() => {
    const intervalId = setInterval(autoScroll, 4000);
    return () => clearInterval(intervalId);
  }, []);

  const scrollLeft = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  return (
    <main>
      <div className="slider-wrapper">
        <HeaderSlider />
      </div>

      <div className="main-content bg-whitesmoke">
        <div className="container">
          <div className="categories py-2">
            <div className="categories-item">

              <div className="carousel-container">
                <button className="carousel-btn left" onClick={scrollLeft}>
                  &lt;
                </button>
                <button className="carousel-btn right" onClick={scrollRight}>
                  &gt;
                </button>

                <div className="categories-carousel" ref={carouselRef}>
                  {categories.map((category) => {
                    const displayCategory = category?.name?.replace("-", " ");
                    return (
                      <Link
                        to={`/category/${category.id}`}
                        key={category.id}
                        className="category-card"
                      >
                        <div className="category-card-content">
                          <p className="category-name text-capitalize">
                            {displayCategory}
                          </p>
                        </div>
                      </Link>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* <Header1 /> */}

            <div className="categories-item">
              <div className="title-md d-flex justify-content-between align-items-center">
                <h3>See some Products</h3>
                <Link to="/AllProducts" className="text-decoration-none">
                  <span className="see-all">See All Products</span>
                </Link>
              </div>

              {productStatus === STATUS.LOADING ? (
                <Loader />
              ) : (
                <ProductList products={products} />
              )}
            </div>
          </div>
        </div>
        {/* <Footer1 /> */}
      </div>
    </main>
  );
};

export default HomePage;

